import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../Utility";

export const initialState = {
  loading: false,
  error: null,
  data: [],
  message: null,

  totalRecords: 0,
  currentPage: 1,
  totalPages: 0,
  limit: 10,
  count: 0,

  page: null,
  loadedPages: [],
  hasMore: true,

  billDetail: null,
  billDetailLoading: false,
  billDetailError: null,

  addEditError: null,
  addEditSuccess: null,
  addEditLoading: false,
  redirectTo: null,
  billCategoryList: [],
};

const billListStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: null,
    message: null,
    redirectTo: null,
  });
};

const billListFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    data: [],
    message: null,
    redirectTo: null,
    loadedPages: [],
    hasMore: true,
  });
};

const billListing = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
    data: action.data,
    filterData: action.data,
    message: action.message,
    page: action.page,
    billDetailError: null,
    billDetail: null,
    redirectTo: null,
    totalRecords: action.totalRecords,
    currentPage: action.currentPage,
    totalPages: action.totalPages,
    limit: action.limit,
    count: action.count,
  });
};

const billDetailStart = (state, action) => {
  return updateObject(state, {
    billDetailLoading: true,
    billDetailError: null,
  });
};

const billDetailSuccess = (state, action) => {
  return updateObject(state, {
    billDetailLoading: false,
    billDetail: action.data,
    billDetailError: null,
  });
};

const billDetailFail = (state, action) => {
  return updateObject(state, {
    billDetailLoading: false,
    billDetail: null,
    billDetailError: action.error,
  });
};

const addEditSuccess = (state, action) => {
  return updateObject(state, {
    addEditSuccess: action.message,
    redirectTo: action.redirectTo,
    addEditLoading: false,
  });
};

const addEditFail = (state, action) => {
  return updateObject(state, {
    addEditError: action.error,
    addEditLoading: false,
  });
};

const addEditStart = (state, action) => {
  return updateObject(state, {
    addEditError: null,
    addEditSuccess: null,
    addEditLoading: true,
  });
};

const filterList = (state, action) => {
  const filterText = (action.text || "").toLowerCase();
  const filteredItems = state.data.filter((item) => {
    return item.Reference && item.Reference.toLowerCase().includes(filterText);
  });
  return updateObject(state, { data: filteredItems });
};

const updateBillLineItemStart = (state, action) => {
  return updateObject(state, {
    billDetailLoading: true,
    billDetailError: null,
  });
};

const updateBillLineItemSuccess = (state, action) => {
  return updateObject(state, {
    billDetailLoading: false,
    billDetail: action.data,
    billDetailError: null,
  });
};

const updateBillLineItemFail = (state, action) => {
  return updateObject(state, {
    billDetailLoading: false,
    billDetailError: action.error,
  });
};

const BillReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BILL_LIST_START:
      return billListStart(state, action);
    case actionTypes.BILL_LIST_FAIL:
      return billListFail(state, action);
    case actionTypes.BILL_LIST_SUCCESS:
      return billListing(state, action);
    case actionTypes.BILL_DETAIL_START:
      return billDetailStart(state, action);
    case actionTypes.BILL_DETAIL_SUCCESS:
      return billDetailSuccess(state, action);
    case actionTypes.BILL_DETAIL_FAIL:
      return billDetailFail(state, action);
    case actionTypes.BILL_ADD_EDIT_SUCCESS:
      return addEditSuccess(state, action);
    case actionTypes.BILL_ADD_EDIT_FAIL:
      return addEditFail(state, action);
    case actionTypes.BILL_ADD_EDIT_START:
      return addEditStart(state, action);
    case actionTypes.BILL_LIST_FILTER:
      return filterList(state, action);
    // New cases for updateBillLineItem
    case actionTypes.UPDATE_BILL_LINE_ITEM_START:
      return updateBillLineItemStart(state, action);
    case actionTypes.UPDATE_BILL_LINE_ITEM_SUCCESS:
      return updateBillLineItemSuccess(state, action);
    case actionTypes.UPDATE_BILL_LINE_ITEM_FAIL:
      return updateBillLineItemFail(state, action);
    default:
      return state;
  }
};

export default BillReducer;
